module.exports = __webpack_public_path__ + "static/scale-model-of-providence-rhode-island-d8cd2e05d302953dd2e68ddb28c5e7b3.png";